import { useState, useCallback, useEffect, useMemo } from "react";
import { domain, token } from "../../../Security";
import axios from "../../../../api/apiClient";
import { useGeneralMessage } from "../../../../common/APICommon"; // Import your hook

export const useSalaryAdvanceRequest = (user) => {
  const [loading, setLoading] = useState(false);
  const [requests, setRequests] = useState([]);
  const [showHistory, setShowHistory] = useState(false);
  const [errorState, setErrorState] = useState(false);
  const [formData, setFormData] = useState({
    amount: "",
    dateRequested: "",
    reason: "",
  });

  // INITIALIZE professional message hook
  const { showMessage, message, isSuccess, showGeneralMessage } = useGeneralMessage();

  const authConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  const fetchHistory = useCallback(async () => {
    if (!user?.employeePersonalInformationId) return;
    const apiUrl = domain + `/api/SalaryAdvanceRequest/my-requests/${user.employeePersonalInformationId}`;
    try {
      const response = await axios.get(apiUrl, authConfig);
      setRequests(response.data);
    } catch (error) {
      console.error("Error fetching history:", error);
    }
  }, [user?.employeePersonalInformationId]);

  useEffect(() => {
    if (showHistory) fetchHistory();
  }, [showHistory, fetchHistory]);

  const submitRequest = useCallback(async (e) => {
    if (e) e.preventDefault();

    if (!formData.amount || !formData.dateRequested || !formData.reason) {
      setErrorState(true);
      showGeneralMessage("Please fill up all required fields.", false); // Professional Alert
      return;
    }

    const apiUrl = domain + "/api/SalaryAdvanceRequest";
    setLoading(true);

    try {
      const payload = {
        EmployeePersonalInformationId: user?.employeePersonalInformationId,
        RequestedDate: formData.dateRequested,
        Amount: parseFloat(formData.amount),
        Reason: formData.reason,
      };

      await axios.post(apiUrl, payload, authConfig);

      // SUCCESS CASE
      setFormData({ amount: "", dateRequested: "", reason: "" });
      setErrorState(false);
      await fetchHistory();
      showGeneralMessage("Salary advance request submitted successfully!", true); // Professional Alert
      
    } catch (error) {
      // ERROR CASE
      const serverMessage = error.response?.data?.message || "Failed to submit request.";
      showGeneralMessage(serverMessage, false); // Professional Alert
    } finally {
      setLoading(false);
    }
  }, [formData, user, fetchHistory, showGeneralMessage]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const employeeInfo = useMemo(() => [
    { label: "Employee Id", value: user?.employeeId || "N/A" },
    { label: "Employee Name", value: user?.employeePersonalInformationFullName || "N/A" },
    { label: "Unit/Department", value: user?.departmentDescription || "N/A" },
    { label: "Vessel", value: user?.vesselName || "N/A" },
    { label: "Title", value: user?.positionDescription || "N/A" },
    { label: "Employee Status", value: user?.employeeStatus || "Active" },
  ], [user]);

  return {
    loading,
    requests,
    formData,
    employeeInfo,
    errorState,
    localToday: new Date().toISOString().split("T")[0],
    showHistory,
    setShowHistory,
    handleInputChange,
    submitRequest,
    // EXPOSE message states to the UI
    alertProps: { showMessage, message, isSuccess } 
  };
};